import { Component, OnInit, OnChanges, SimpleChanges, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { HCPService } from '../../../../../services/hcp.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorPersonalDetailInfoRequest, ActorPersonalDetailInfoController, ActorContactInfoController, ActorContactInfoRequest } from '../../../../../models/profileinfo/profileinfo.model';
import { ActorImageController, OTFormsByFormattedCodeController, OTFormDetailByReportCodeRequest, OTFormsByFormattedCodeRequest, OTFormDetailByReportCodeController, SectionData, PatientVisitDetailsController, PatientVisitDetailsRequest, BillHeaderWithItemsController, BillHeaderWithItemsRequest, RefundDetailsData, RefundDetailsRequest, RefundItemDetailsController, RefundDetailsController } from '../../../../../models/actor/actor';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { CustomDateTimeService } from '../../../../../services/datetime.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../../../../../src/app/ncs/services/actor.service';
import { NgbFsEditAttrModal } from './modal/fseditattr.modal';
import { NgbFsEditTextModal } from './modal/fsedittext.modal';
import { NgbFsEditImageModal } from './modal/fseditimage.modal';
import { NgbFsEditViewModal } from './modal/fseditview.modal';
import { PrintService } from '../../../../../../../../src/app/ncs/services/print.service';
import { NgbAddFormsModal } from './modal/addforms.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'servicesview',
  templateUrl: './servicesview.component.html',
  styleUrls: ['./servicesview.component.scss']
})

export class ServicesViewComponent implements OnInit, OnChanges {

  @Input() ActorCode: number;
  @Input() ActorType: number;
  @Input() FormattedCode: string;
  @Input() CanEdit: number;
  @Input() CanShow: number;
  @Input() PatientCode: number;

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['ActorCode'] && changes['ActorCode'].currentValue) || (changes['PatientCode'] && changes['PatientCode'].currentValue)) {
      this.LoadServices();
      this.RefundItems();
    }
  }
  //@Input() reportCode: number;
  //@Input() TemplateName: string;
  //@Input() Date: Date;
  //@Input() Sign1: string;
  //@Input() Sign2: string;
  public isRequesting: boolean = false;
  public ListView: boolean = true;
  public backtolist: boolean = false;
  public ItemsData: boolean = false;
  public FormList: boolean = false;
  public Formedit: boolean = false;
  public viewhealthrecord: boolean = false;
  public TemplateName: string;
  public Date: Date;
  public Sign1: string;

  public Sign2: string;
  public RPCode: any;
  CurrentActorPersonalDetailInfoRequest: ActorPersonalDetailInfoRequest;
  CurrentActorPersonalDetailInfoController: ActorPersonalDetailInfoController;

  ValueChangeActorImageController: ActorImageController;

  public ApiResData: ApiResponseModel;

  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();
  public PatientFormattedCode: string;

  DOB: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;

  //
  public key: ActorPersonalDetailInfoController;


  @Input()
  get Key() {
    return this.key;
  }

  @Output() personalInfoChange = new EventEmitter();
  //set Key(value: ActorPersonalDetailInfoController) {
  //  this.key = value;
  //  //  alertFunctions.AlertParam(this.Key);
  //  console.log('personalInfoChange');
  //  this.personalInfoChange.emit(this.key);
  //}
  //
  public onInput(value: Date): void {

    console.log('value-->' + value);

    this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = value;
  }
  //CurrentOTFormsByFormattedCodeController: OTFormsByFormattedCodeController[];
  //CurrentOTFormsByFormattedCodeRequest: OTFormsByFormattedCodeRequest;

  //OpenForm(data: OTFormsByFormattedCodeController) {
  //  this.LoadMedicalHistory(data.PatientReportCode);
  //  this.ListView = false;
  //  this.backtolist = true;

  //}
  //LoadMedicalRecords() {
  //  this.CurrentOTFormsByFormattedCodeRequest = new OTFormsByFormattedCodeRequest();

  //  this.CurrentOTFormsByFormattedCodeRequest.ConditionalOperator = 10;
  //  this.CurrentOTFormsByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetOTFormsByFormattedCodeController();

  //}

  //GetOTFormsByFormattedCodeController() {
  //  if (isNaN(this.ActorCode))
  //    return;

  // // alert('loading forms: ' + this.ActorCode);
  //  this.StartRefreshing();
  //  this.CurrentOTFormsByFormattedCodeRequest.FormattedCode = this.FormattedCode;
  //  //alert('loading forms: ' + this.FormattedCode);
  //  //this.LoadMedicalHistory_new();


  //  //alert("LOading guarding adata");
  //  //alert(this.CurrentGuardianInfoRequest.ActorCode);

  //  this.actorservice.GetOTFormsByFormattedCodeController(this.CurrentOTFormsByFormattedCodeRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //       this.CurrentOTFormsByFormattedCodeController = this.ApiResData.Result;
  //        //var reportCode: number =
  //        //  this.CurrentOTFormsByFormattedCodeController.filter
  //        //    (x => x.ReportType != 'VIT' && x.TemplateName == 'Medical History')[0].PatientReportCode;
  //        //this.stopRefreshing();

  //        //this.LoadMedicalHistory(reportCode);
  //        this.stopRefreshing();
  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}
  CurrentBillHeaderWithItemsController: BillHeaderWithItemsController[];
  BillCodesOP: BillHeaderWithItemsController[];
  BillCodesRX: BillHeaderWithItemsController[];
  AllBills: BillHeaderWithItemsController[];
  SelectedBillItems: BillHeaderWithItemsController[];
  CurrentBillHeaderWithItemsRequest: BillHeaderWithItemsRequest;


  LoadServices() {
    // alert("one");
    this.CurrentBillHeaderWithItemsRequest = new BillHeaderWithItemsRequest();

    //this.CurrentPatientVisitDetailsRequest.ConditionalOperator = 10;
    this.CurrentBillHeaderWithItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetBillHeaderWithItemsController();

  }

  GetBillHeaderWithItemsController() {


    // alert('loading forms: ' + this.ActorCode);
    this.StartRefreshing();
    this.CurrentBillHeaderWithItemsRequest.FromDate = new Date();
    this.CurrentBillHeaderWithItemsRequest.ToDate = new Date();
    this.CurrentBillHeaderWithItemsRequest.ConditionalOperator = 20;
    this.CurrentBillHeaderWithItemsRequest.ActorCode = this.ActorCode;
    // this.CurrentBillHeaderWithItemsRequest.ActorCode = 37855;
    //alert('loading forms: ' + this.FormattedCode);
    //this.LoadMedicalHistory_new();


    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetBillHeaderWithItemsController(this.CurrentBillHeaderWithItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillHeaderWithItemsController = this.ApiResData.Result;

          var filterArray = this.CurrentBillHeaderWithItemsController.reduce((accumalator, current) => {
            if (!accumalator.some(item => item.BillCode === current.BillCode )) {


              accumalator.push(current);
            }
            return accumalator;
          }, []);
        //  this.BillCodesOP = filterArray;
          this.BillCodesOP = filterArray.filter(
            function (a) {
              return a.BillType != 'RXBILL';
            });
         // this.BillCodesRX = filterArray;
          this.BillCodesRX = filterArray.filter(
            function (b) {
              return b.BillType == 'RXBILL';
            });
          //var reportCode: number =
          //  this.CurrentOTFormsByFormattedCodeController.filter
          //    (x => x.ReportType != 'VIT' && x.TemplateName == 'Medical History')[0].PatientReportCode;
          //this.stopRefreshing();

          //this.LoadMedicalHistory(reportCode);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  //LoadServices2() {

  //  this.CurrentBillHeaderWithItemsRequest = new BillHeaderWithItemsRequest();
  //  this.CurrentBillHeaderWithItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.GetBillHeaderWithItemsController2();

  //}

  //GetBillHeaderWithItemsController2() {

  //  this.StartRefreshing();
  //  this.CurrentBillHeaderWithItemsRequest.FromDate = new Date();
  //  this.CurrentBillHeaderWithItemsRequest.ToDate = new Date();
  //  this.CurrentBillHeaderWithItemsRequest.ConditionalOperator = 20;
  //  this.CurrentBillHeaderWithItemsRequest.ActorCode = this.ActorCode;
  //  this.actorservice.GetBillHeaderWithItemsController(this.CurrentBillHeaderWithItemsRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentBillHeaderWithItemsController = this.ApiResData.Result;

  //        this.BillCodesRX = this.CurrentBillHeaderWithItemsController.filter(
  //          function (b) {
  //            return b.BillType == 'RXBILL';
  //          });

  //        this.stopRefreshing();

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //      }


  //    );
  //}

    CurrentRefundDetailsData: RefundDetailsData[];
    CurrentRefundDetailsMaster: RefundDetailsData;
    CurrentRefundDetailsRequest: RefundDetailsRequest;
    // MasterData: RefundDetailsController;
    RefundData: RefundItemDetailsController[];
    RefundItems() {
        //this.spinner.show();
        this.CurrentRefundDetailsRequest = new RefundDetailsRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentRefundDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        // this.pdata = this.CurrentRefundDetailsData;
        // this.pdata = this.CurrentFollicularScansBetweenDateController;
        this.GetRefundDetailsController();
    }


    GetRefundDetailsController() {
        this.StartRefreshing();
        //this.spinner.show();
        //BranchcodeData:AppData.Instance().SelectedBranchCode
      this.CurrentRefundDetailsRequest.Facility = AppData.Instance().SelectedBranchCode;
      this.CurrentRefundDetailsRequest.RefundCode = 0;
      this.CurrentRefundDetailsRequest.PatientCode = this.PatientCode;
        //this.CurrentRefundDetailsRequest.PatientCode = 31242;
        this.CurrentRefundDetailsRequest.ConditionalOperator = 20;
        this.CurrentRefundDetailsRequest.FromDate = new Date();
        this.CurrentRefundDetailsRequest.ToDate = new Date();
        this.CurrentRefundDetailsRequest.RequestStatus = "";

        this.actorservice.RefundDetailsData(this.CurrentRefundDetailsRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentRefundDetailsData = this.ApiResData.Result || [];
                    this.CurrentRefundDetailsMaster = this.ApiResData.Result;
                    if (this.CurrentRefundDetailsMaster && (this.CurrentRefundDetailsMaster as any).Items) {
                        this.RefundData = (this.CurrentRefundDetailsMaster as any).Items;
                    } else {
                        this.RefundData = [];
                    }
                    //this.MasterData = this.CurrentRefundDetailsMaster.Master;
                 
                    //this.pdata = this.CurrentRefundDetailsController;
                    // this.spinner.hide();
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
                    //this.spinner.hide();
                    this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.LoadOvaryData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    
  onChange(Event: any) {
    this.spinner.show();
    this.ItemsData = true;
    if (Event != null) {
      var a = this.CurrentBillHeaderWithItemsController.filter(X => X.BillCode === Event)
      if (a.length > 0) {
        this.SelectedBillItems = a;
        // alert(this.ActivityDate);
      }
    }
    this.spinner.hide();
  }
  //GetItemsAllBills(BillCode: string) {
  //  if (BillCode != null) {
  //    var a = this.CurrentBillHeaderWithItemsController.filter(X => X.BillCode === BillCode)
  //    return a;
  //  }
  //}
  GetItemsOP(BillCode: string) {
    if (BillCode != null) {
      var a = this.CurrentBillHeaderWithItemsController.filter(X => X.BillCode === BillCode)
      return a;
    }
  }
  GetItemsRX(BillCode: string) {
    if (BillCode != null) {
      var b = this.CurrentBillHeaderWithItemsController.filter(X => X.BillCode === BillCode)
      return b;
    }
  }
  Backtolist() {
    this.FormList = true;
    this.Formedit = false;
  }

  BackToHealthrecords() {
    //this.viewhealthrecord = true;
    this.ListView = true;
    this.FormList = false;
    //this.Formedit = false;
    //this.router.navigate(['healins/MedicalRecords']);
  }
  //GetOTFormDetailByReportCodeController() {
  //  this.StartRefreshing();
  ////  //alert("LOading guarding adata");
  ////  //alert(this.CurrentGuardianInfoRequest.ActorCode);

  //  this.actorservice.GetOTFormsByFormattedCodeController(this.CurrentOTFormsByFormattedCodeRequest)
  //    .subscribe((result) => {
  //     this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        this.CurrentOTFormsByFormattedCodeController = this.ApiResData.Result;
  ////        //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

  ////        //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  ////        //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
  //     this.stopRefreshing();

  //      }
  //    else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //        }
  //        else {
  //         alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //       }
  //      }

  //    },


  //  (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();



  //     }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.stopRefreshing();
  //        }
  //    }


  //    );
  //}
  constructor(private router: Router,
    public printService: PrintService,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService, private actorservice: ActorService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private spinner: NgxSpinnerService, private tosterservice: NGXToastrService) {
    //stepObject.init();
  }

  ngOnInit() {
    this.LoadServices();
    //this.LoadServices2();
    this.RefundItems();
    //this.LoadMedicalHistory();
    this.PatientFormattedCode = this.FormattedCode;
    //alert(this.PatientFormattedCode);
    ////this.LoadMedicalHistroy();
    //this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    //this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    //this.minDate = { year: 1900, month: 1, day: 1 };

    //this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;
    //this.CurrentActorPersonalDetailInfoRequest = new ActorPersonalDetailInfoRequest();
    //this.CurrentActorPersonalDetailInfoController = new ActorPersonalDetailInfoController();
    //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
    //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.ActorCode;
    //this.CurrentActorPersonalDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.ValueChangeActorImageController = new ActorImageController();
    //if (this.CanShow === 1) {
    //  this.GetActorPersonalDetailInfoController();
    //}

  }

  onactorImageInfoChange(event: any) {


    if (event != null) {

      this.ValueChangeActorImageController = event;

      if (this.ValueChangeActorImageController.ActorImageFileUrl != null) {
        //console.log('this.ValueChangeActorImageController.ActorImageFileUrl-->' + this.ValueChangeActorImageController.ActorImageFileUrl);

        this.CurrentActorPersonalDetailInfoController.ActorImageFileUrl = this.ValueChangeActorImageController.ActorImageFileUrl;
      }


    }

  }
  onSubmit() {

    this.StartRefreshing();

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.customdatetimeservice.converToLocalTime(this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //  console.log('DateOfBirth----------' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth);
    //}
    // console.log('this.DOB--->' + this.DOB);
    if (this.DOB != null) {



      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));;

      // console.log('this.DateOfBirth--->' + this.CurrentActorPersonalDetailInfoRequest.DateOfBirth );
    }
    this.hcpservice.SaveActorPersonalDetailInfo(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorPersonalDetailInfoController();

            // alertFunctions.AlertParam('Saved Successfully.....!');

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');



            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );

  }
  //Back() {
  //    this.ListView = true;
  //    this.backtolist = false;
  //}
  //ngAfterViewInit() {
  //  //pSteps.loadStep();
  //}
  OpenForm(l: OTFormsByFormattedCodeController) {
    var reportcode = l.PatientReportCode;
    //alert(reportcode);
    this.ListView = false;
    this.FormList = true;

    this.LoadMedicalHistory(reportcode);
    this.TemplateName = l.TemplateName;
    this.Date = l.RegistrationDate;
    this.Sign1 = l.Sign1Name;
    this.Sign2 = l.Sign2Name;
  }
  FormData: SectionData[];
  CurrentOTFormDetailByReportCodeController: OTFormDetailByReportCodeController[];
  CurrentOTFormDetailByReportCodeRequest: OTFormDetailByReportCodeRequest;
  LoadMedicalHistory(reportcode: number) {
    this.spinner.show();
    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
    r1.ConditionalOperator = 10;

    r1.PatientReportCode = reportcode.toString();
    this.RPCode = reportcode.toString();
    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
      ((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.stopRefreshing();
          //  this.CurrentOTFormDetailByReportCodeController = this.ApiResData.Result;
          //alert(this.CurrentOTFormDetailByReportCodeController);
          // var reportCode: number = this.CurrentOTFormsByFormattedCodeController[0].PatientReportCode;
          this.FormData = this.ApiResData.Result;
          //if (this.FormData.length > 0)
          //  alert(this.FormData[0].Title);
          //else {
          //  alert("no data retrieved");
          //}
          this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  //LoadMedicalHistory_new() {

  //    var r1: OTFormDetailByReportCodeRequest = new OTFormDetailByReportCodeRequest();
  //    r1.ConditionalOperator = 10;
  //    r1.PatientFormattedCode = this.FormattedCode;
  //    r1.PatientReportCode = "";
  //    r1.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //    this.actorservice.GetOTFormDetailByReportCodeController(r1).subscribe
  //        ((result) => {
  //            this.ApiResData = result;
  //            if (!this.ApiResData.hasError) {
  //                this.stopRefreshing();

  //                this.FormData = this.ApiResData.Result;




  //            }
  //            else {
  //                this.stopRefreshing();
  //                if (this.ApiResData.ErrorData != "") {

  //                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //                }
  //                else {
  //                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //                }
  //            }

  //        },


  //            (error) => {

  //                if (error == "401 - Unauthorized") {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();



  //                }
  //                else {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();
  //                }
  //            }


  //        );

  //}
  displyeditattr(l: SectionData) {
    //this.FormList = false;
    //this.Formedit = true;

    const modalRef = this.modalService.open(NgbFsEditAttrModal,
      {
        centered: true,
        size: "xl"

      })
    modalRef.componentInstance.sectionData = l;
    modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
    modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
    modalRef.componentInstance.FormattedCode = this.FormattedCode;
    modalRef.componentInstance.TemplateName = this.TemplateName;
    modalRef.componentInstance.Date = this.Date;
    modalRef.componentInstance.Sign1 = this.Sign1;
    modalRef.componentInstance.Sign2 = this.Sign2;
    modalRef.componentInstance.TitleName = l.Title;
    // modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
    //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  displyeditText(l: SectionData) {
    //this.FormList = false;
    //this.Formedit = true;
    const modalRef = this.modalService.open(NgbFsEditTextModal,
      {
        centered: true,
        size: "xl"

      })
    modalRef.componentInstance.sectionData = l;
    modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
    modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
    modalRef.componentInstance.FormattedCode = this.FormattedCode;
    modalRef.componentInstance.TemplateName = this.TemplateName;
    modalRef.componentInstance.Date = this.Date;
    modalRef.componentInstance.Sign1 = this.Sign1;
    modalRef.componentInstance.Sign2 = this.Sign2;
    modalRef.componentInstance.TitleName = l.Title;
    // modalRef.componentInstance.CurrentActorEditEmergencyInfoRequest = this.CurrentActorEditEmergencyInfoRequest;
    //modalRef.result.then(x => { this.GetEmergencyContactInfoController() })
  }
  displyeditImage(l: SectionData) {
    const modalRef = this.modalService.open(NgbFsEditImageModal,
      {
        centered: true,
        size: "xl"

      })
    modalRef.componentInstance.sectionData = l;
    modalRef.componentInstance.SectionSequenceNO = l.SectionSequenceNO;
    modalRef.componentInstance.SectionTypeCode = l.SectionTypeCode;
    modalRef.componentInstance.FormattedCode = this.FormattedCode;
    modalRef.componentInstance.TemplateName = this.TemplateName;
    modalRef.componentInstance.Date = this.Date;
    modalRef.componentInstance.Sign1 = this.Sign1;
    modalRef.componentInstance.Sign2 = this.Sign2;
    modalRef.componentInstance.TitleName = l.Title;
  }
  displytextview() {
    const modalRef = this.modalService.open(NgbFsEditViewModal,
      {
        centered: true

      })
  }
  AddForm() {

    const modalRef = this.modalService.open(NgbAddFormsModal,
      {

      })
    modalRef.componentInstance.FormattedCode = this.FormattedCode;
    modalRef.componentInstance.PatientCode = this.PatientCode;

  }

  GetActorPersonalDetailInfoController() {

    this.StartRefreshing();
    this.hcpservice.GetActorPersonalDetailInfoController(this.CurrentActorPersonalDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {


          this.CurrentActorPersonalDetailInfoController = this.ApiResData.Result[0];

          this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
          this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
          this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
          this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
          this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
          this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
          this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;



          if (this.CurrentActorPersonalDetailInfoController.DateOfBirth != null) {

            var SDOB = new Date(this.CurrentActorPersonalDetailInfoController.DateOfBirth);
            ;
            if (SDOB.getFullYear() > 1900) {

              this.DOB = {

                year: SDOB.getFullYear(),
                month: SDOB.getMonth() + 1,
                day: SDOB.getDate()
              }
            }
            else {
              this.DOB = {

                year: 1900,
                month: 1,
                day: 1
              }
            }
          }
          this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
          this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
          this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
          this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
          this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
          this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
          this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
          this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
          this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
          this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
          this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
          this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
          //
          //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
          //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
          this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
          this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
          this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
          this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA"
          //this.CurrentActorPersonalDetailInfoController.Country;
          this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
          this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
          this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
          this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
          this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
          this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;
          this.CurrentActorPersonalDetailInfoRequest.Zip = this.CurrentActorPersonalDetailInfoController.Zip;
          //
          this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
          this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

          //this.key = this.ApiResData.Result[0];

          //this.personalInfoChange.emit(this.key);
          // console.log('this.personalInfoChange' + this.key.DisplayName);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  OpenEditContent() {
    if (this.CanEdit === 1) {
      this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.Salutation = this.CurrentActorPersonalDetailInfoController.Salutation;
      this.CurrentActorPersonalDetailInfoRequest.FirstName = this.CurrentActorPersonalDetailInfoController.FirstName;
      this.CurrentActorPersonalDetailInfoRequest.MiddleName = this.CurrentActorPersonalDetailInfoController.MiddleName;
      this.CurrentActorPersonalDetailInfoRequest.LastName = this.CurrentActorPersonalDetailInfoController.LastName;
      this.CurrentActorPersonalDetailInfoRequest.DisplayName = this.CurrentActorPersonalDetailInfoController.DisplayName;
      this.CurrentActorPersonalDetailInfoRequest.SocialSecurityNumber = this.CurrentActorPersonalDetailInfoController.SocialSecurityNumber;
      this.CurrentActorPersonalDetailInfoRequest.DateOfBirth = this.CurrentActorPersonalDetailInfoController.DateOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.PlaceOfBirth = this.CurrentActorPersonalDetailInfoController.PlaceOfBirth;
      this.CurrentActorPersonalDetailInfoRequest.Gender = this.CurrentActorPersonalDetailInfoController.Gender;
      this.CurrentActorPersonalDetailInfoRequest.BloodGroup = this.CurrentActorPersonalDetailInfoController.BloodGroup;
      this.CurrentActorPersonalDetailInfoRequest.Nationality = this.CurrentActorPersonalDetailInfoController.Nationality;
      this.CurrentActorPersonalDetailInfoRequest.Religion = this.CurrentActorPersonalDetailInfoController.Religion;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification1 = this.CurrentActorPersonalDetailInfoController.BirthIdentification1;
      this.CurrentActorPersonalDetailInfoRequest.BirthIdentification2 = this.CurrentActorPersonalDetailInfoController.BirthIdentification2;
      this.CurrentActorPersonalDetailInfoRequest.LiveIn = this.CurrentActorPersonalDetailInfoController.LiveIn;
      this.CurrentActorPersonalDetailInfoRequest.Occupation = this.CurrentActorPersonalDetailInfoController.Occupation;
      this.CurrentActorPersonalDetailInfoRequest.MaritalStatus = this.CurrentActorPersonalDetailInfoController.MaritalStatus;
      this.CurrentActorPersonalDetailInfoRequest.HasWorkPermit = this.CurrentActorPersonalDetailInfoController.HasWorkPermit;
      this.CurrentActorPersonalDetailInfoRequest.IsConvicted = this.CurrentActorPersonalDetailInfoController.IsConvicted;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesSpoken = this.CurrentActorPersonalDetailInfoController.LanguagesSpoken;
      this.CurrentActorPersonalDetailInfoRequest.LanguagesRead = this.CurrentActorPersonalDetailInfoController.LanguagesRead;
      //
      //this.CurrentActorPersonalDetailInfoRequest.ConditionalOperator = 2;
      //this.CurrentActorPersonalDetailInfoRequest.ActorCode = this.CurrentActorPersonalDetailInfoController.ActorCode;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine1 = this.CurrentActorPersonalDetailInfoController.AddressLine1;
      this.CurrentActorPersonalDetailInfoRequest.AddressLine2 = this.CurrentActorPersonalDetailInfoController.AddressLine2;
      this.CurrentActorPersonalDetailInfoRequest.City = this.CurrentActorPersonalDetailInfoController.City;
      this.CurrentActorPersonalDetailInfoRequest.State = this.CurrentActorPersonalDetailInfoController.State;
      this.CurrentActorPersonalDetailInfoRequest.Country = "AMERICA";
      //this.CurrentActorPersonalDetailInfoController.Country;
      this.CurrentActorPersonalDetailInfoRequest.Telephone1 = this.CurrentActorPersonalDetailInfoController.Telephone1;
      this.CurrentActorPersonalDetailInfoRequest.Telephone2 = this.CurrentActorPersonalDetailInfoController.Telephone2;
      this.CurrentActorPersonalDetailInfoRequest.Fax1 = this.CurrentActorPersonalDetailInfoController.Fax1;
      this.CurrentActorPersonalDetailInfoRequest.Fax2 = this.CurrentActorPersonalDetailInfoController.Fax2;
      this.CurrentActorPersonalDetailInfoRequest.Email = this.CurrentActorPersonalDetailInfoController.Email;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactPersonName = this.CurrentActorPersonalDetailInfoController.EmergencyContactPersonName;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo1 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo1;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyContactNo2 = this.CurrentActorPersonalDetailInfoController.EmergencyContactNo2;
      this.CurrentActorPersonalDetailInfoRequest.EmergencyAddress = this.CurrentActorPersonalDetailInfoController.EmergencyAddress;

      //
      this.CurrentActorPersonalDetailInfoRequest.ProfileSummary = this.CurrentActorPersonalDetailInfoController.ProfileSummary;
      this.CurrentActorPersonalDetailInfoRequest.ProfileTitle = this.CurrentActorPersonalDetailInfoController.ProfileTitle;

    }
    else {
      alertFunctions.AlertParam('Access Denied  Please Contact Admin....!');
    }

  }
  printservices() {
    this.printService.printDocument2(this.FormattedCode, 0

    );
    this.printService.printDocument("servicesviewPV",
      {
        ActorCodeData: this.ActorCode, FormattedCodeData: this.FormattedCode, PatientCodeData: this.PatientCode
      }
    );
  }

}
